import React from "react";

import {
  AreaChart,
  Area,
  ResponsiveContainer,
  CartesianGrid,
  XAxis,
  YAxis,
} from "recharts";
import { _sliceToLastNonZero, formatDate, getPreviousMonthsData, getValueFromDotSeparatedKey } from "../utils";


export default function IframeChart({
  cardListViewData,
  isWeekly,
  type,
  statKey,
  formatter,
  returnData,
  snapshotTitle,
}) {
  cardListViewData = _sliceToLastNonZero(cardListViewData, type);


  console.log(snapshotTitle, "snapshotTitle");

  const monthlyData = getPreviousMonthsData(cardListViewData);

  const keyStat =
    monthlyData &&
    monthlyData[1] &&
    monthlyData[1][type.key] &&
    getValueFromDotSeparatedKey(monthlyData[1][type.key], statKey)
      ? formatter(
          getValueFromDotSeparatedKey(monthlyData[1][type.key], statKey)
        )
      : "--";

  const data = cardListViewData
    .slice(isWeekly !== "+1MONTH" ? -53 : 0)
    .map((item) => {
      return {
        name: item.val,
        val: item.val,
        value:
          item[type.key] && getValueFromDotSeparatedKey(item[type.key], statKey)
            ? getValueFromDotSeparatedKey(item[type.key], statKey)
            : 0,
      };
    });

  if (returnData) {
    return { stat: keyStat };
  }

  const formatXAxis = (tickItem) => {
    return formatDate(tickItem, isWeekly);
  };

  const formatYAxisValue = (tickItem) => {
    if (tickItem) {
      return formatter(tickItem);
    } else {
      return "";
    }
  };
  const ChartContainer = () => {
    return (
      <>
        {" "}
        <ResponsiveContainer width={"100%"}>
          <AreaChart
            data={data}
            margin={{ top: 20, right: 0, left: 0, bottom: 60 }}
          >
            <XAxis
              dataKey="name"
              tickFormatter={formatXAxis}
              angle={-45}
              textAnchor="end"
              dy={10}
              dx={-5}
            />
            <YAxis dataKey="value" tickFormatter={formatYAxisValue} />
            <Area
              type="monotone"
              dataKey="value"
              stroke={`${type.checkedColor}`}
              fill={`${type.checkedColor}`}
              fillOpacity={0.2}
            />
            <CartesianGrid stroke="#eee" strokeDasharray="5 5" />
          </AreaChart>
        </ResponsiveContainer>
      </>
    );
  };
  return (
    <>
      <div style={{ height: 400, width: "100%" }}>
        <ChartContainer />
      </div>
    </>
  );
}
